import { render, staticRenderFns } from "./CustodiaHistoriasPagination.vue?vue&type=template&id=8c98eda2&"
import script from "./CustodiaHistoriasPagination.vue?vue&type=script&lang=js&"
export * from "./CustodiaHistoriasPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports